module.exports = __webpack_public_path__ + "static/Reed-Shop-Music-6a92d38cb51c57fc72f8248957d79ee2.jpg";